import { useSelector } from 'react-redux';

import appStore from 'redux/stores/app.store';
import httpService from 'services/HttpService';
import { generateURLRappiServices } from 'shared/utils/urls';

import { MOZART_API_PATH } from './mozart.const';

import type { PartnerId, Store } from 'shared/domain';
import type { NotificationsRawResp } from './mozart.response';
import type { NumberOfUnseenAlerts } from 'features/mozart-notifications/domain';
import type {
  NotificationSeenByIdReq,
  TurnOffProductByStoreIdReq,
} from './mozart.request';

export function readUnseenAlerts() {
  return useSelector<any, NumberOfUnseenAlerts>(
    s => s.partnerReducer.unseenAlerts,
  );
}

export function readPartnerIdFromProfile() {
  return useSelector<any, PartnerId>(s => s.partnerReducer.profile.id);
}

export function readStoresFromProfile(params?: { asHook: boolean }): Store[] {
  const { asHook = true } = params ?? {};
  const storesAdapted = (s: any): Store => ({ id: s.id, name: s.name });
  const readStoresAsNotHook = () => appStore.getStores().map(storesAdapted);
  const readStoresAsHook = () => {
    const profile = useSelector<any, any>(s => s.partnerReducer.profile);
    return profile.stores.map(storesAdapted);
  };
  return asHook ? readStoresAsHook() : readStoresAsNotHook();
}

export function readAllNotifications() {
  return httpService.get<NotificationsRawResp>(
    generateURLRappiServices({ url: MOZART_API_PATH.ALL_NOTIFICATIONS }),
  );
}

export function updateNotificationSeenById(params: NotificationSeenByIdReq) {
  const { id, payload } = params;
  return httpService.put<boolean>(
    generateURLRappiServices({
      url: MOZART_API_PATH.NOTIFICATION_SEEN_BY_ID,
      pathParams: { id },
    }),
    payload,
  );
}

export function updateTurnOffProduct(params: TurnOffProductByStoreIdReq) {
  const { payload } = params;
  return httpService.put<''>(
    generateURLRappiServices({ url: MOZART_API_PATH.TURN_OFF_PRODUCT }),
    payload,
  );
}

export const mozartRepository = {
  readUnseenAlerts,
  readPartnerIdFromProfile,
  readStoresFromProfile,
  readAllNotifications,
  updateNotificationSeenById,
  updateTurnOffProduct,
};
